import { modalRef, Layer } from './layer';

export { Layer };

export default {
  show: () => modalRef.current?.show()
};
